import GooglePlayIcon from 'assets/images/google-play-badge.png'
import iOSStoreIcon from 'assets/images/ios-store-badge.svg'
import bg from 'assets/images/margin-onboarding-1.png'
import { androidAppStoreUrl, iosAppStoreUrl } from 'constants/appStore'
import React from 'react'
import styled from 'styled-components'

import { Content, Footer, Wrapper } from './styles'

const AppIcons = styled.div`
  display: flex;
  flex-direction: row;

  > img {
    width: 50%;
    cursor: pointer;

    &:nth-child(2) {
      padding: 1rem;
    }
  }
`

const TradeOnMobile = ({ onClose }) => (
  <Wrapper onClose={onClose}>
    <img src={bg} />
    <Content>
      <h1>Trade on mobile, get BTC</h1>
      <p>
        Get a $10 BTC bonus by trading $50 or more on the Exchange mobile app before August 31,
        2022.
      </p>
    </Content>
    <Footer>
      <AppIcons>
        <img onClick={() => window.open(androidAppStoreUrl)} src={GooglePlayIcon} />
        <img onClick={() => window.open(iosAppStoreUrl)} src={iOSStoreIcon} />
      </AppIcons>
    </Footer>
  </Wrapper>
)

export default TradeOnMobile
